var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#00C96F","fillRule":"evenodd"},[React.createElement("path",{"d":"M16.813 16.016c.323 0 .633-.129.862-.357l11.48-11.48v5.935a1.22 1.22 0 0 0 2.438 0V1.236a1.22 1.22 0 0 0-1.219-1.22h-8.878a1.22 1.22 0 1 0 0 2.44h5.935L15.87 13.934a1.22 1.22 0 0 0 .862 2.081h.081z","key":0}),React.createElement("path",{"d":"M30.504 17.187a1.22 1.22 0 0 0-1.22 1.22v10.08c0 .44-.356.798-.796.798H3.252a.797.797 0 0 1-.797-.797V3.252c0-.44.357-.797.797-.797h9.545a1.22 1.22 0 0 0 0-2.439H3.252A3.252 3.252 0 0 0 0 3.268v25.22a3.252 3.252 0 0 0 3.252 3.252h25.236a3.252 3.252 0 0 0 3.252-3.252V18.407a1.22 1.22 0 0 0-1.236-1.22z","key":1})]));
}

ExternalLink.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
